import { makeStyles } from "tss-react/mui"
import { DialogContent, Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { UserType } from "../../../../modules/login/loginTypes"
import { StandardButton } from "../../buttons/StandardButton"
import { StandardDialog } from "../../dialogs/StandardDialog"

const useStyles = makeStyles()((theme) => ({
    dialogContent: {
        padding: "2.5rem",
        paddingTop: "1rem",
        display: "flex",
        gap: "2rem",
        flexDirection: "column",
        margin: "0 auto",
        color: theme.palette.tailwind.slate[950],
    },
}))

type InvalidUserPermissionsDialogProps = Readonly<{
    userType?: UserType
    handleClose: () => void
    handleShowOrderOnBehalfDialog: () => void
}>

export function InvalidUserPermissionsDialog({
    userType,
    handleClose,
    handleShowOrderOnBehalfDialog,
}: InvalidUserPermissionsDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog
            dialogTitle={
                <LocalizedStrict id="create-order-tabs-error">
                    <>You can't place an order</>
                </LocalizedStrict>
            }
            open={true}
            onClose={() => {}}
            hideCloseIcon
            maxWidthProp="sm"
            scroll="body"
        >
            <DialogContent className={classes.dialogContent}>
                <LocalizedStrict id="create-order-tabs-error-body">
                    <Typography variant="subtitle1" textAlign="center">
                        You can't place an order because your account doesn't have the required access. Please contact
                        support if you need more information.
                    </Typography>
                </LocalizedStrict>
                <Stack flexDirection="row" gap="1rem">
                    <LocalizedStrict id="create-order-tabs-error-dialog-close-button">
                        <StandardButton color="grey" variant="outlined" onClick={handleClose}>
                            Go back
                        </StandardButton>
                    </LocalizedStrict>
                    {userType !== UserType.USER && (
                        <LocalizedStrict id="create-order-tabs-error-dialog-confirm-button">
                            <StandardButton onClick={handleShowOrderOnBehalfDialog}>Select another user</StandardButton>
                        </LocalizedStrict>
                    )}
                </Stack>
            </DialogContent>
        </StandardDialog>
    )
}
